import { RadioGroup as MuiRadioGroup } from '@mui/material';

import type { RadioGroupProps } from '@mui/material';
import type { FC } from 'react';

export const RADIO_GROUP_TEST_ID = 'radio-group';

export const RadioGroup: FC<RadioGroupProps> = ({ ...props }) => (
  <MuiRadioGroup data-testid={RADIO_GROUP_TEST_ID} {...props} />
);
